import { metricsMapper } from './mappers';
export function toPulseMetric(metric, getHtmlElementMetadata) {
    return metricsMapper?.[metric.name](metric, getHtmlElementMetadata);
}
//# sourceMappingURL=index.js.map